module.exports = __webpack_public_path__ + "img/35-min.15f3bd0c.jpg";